module.exports = function() {
  return new Worker("/" + "stylus-transpiler.a5f467a1.worker.js");
};